var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79974 3.19971H3.19983C2.77549 3.19971 2.36853 3.36828 2.06848 3.66833C1.76842 3.96838 1.59985 4.37534 1.59985 4.79968V15.9995C1.59985 16.4239 1.76842 16.8308 2.06848 17.1309C2.36853 17.4309 2.77549 17.5995 3.19983 17.5995H14.3997C14.824 17.5995 15.231 17.4309 15.531 17.1309C15.8311 16.8308 15.9996 16.4239 15.9996 15.9995V10.3996",
    stroke: "currentColor",
    strokeWidth: 1.59998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7995 1.99998C15.1178 1.68172 15.5494 1.50293 15.9995 1.50293C16.4496 1.50293 16.8812 1.68172 17.1995 1.99998C17.5177 2.31823 17.6965 2.74988 17.6965 3.19996C17.6965 3.65004 17.5177 4.08169 17.1995 4.39994L9.59961 11.9998L6.39966 12.7998L7.19965 9.59986L14.7995 1.99998Z",
    stroke: "currentColor",
    strokeWidth: 1.59998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9c592cc956c490735893238bb48d5abd.svg";
export { ForwardRef as ReactComponent };